module.exports = __webpack_public_path__ + "img/enroll-icon.0266d52a.png";